import React from 'react'
import { AutocorrectionPreference } from './AutocorrectionPreference.js'
import './index.css'

const Checkbox = ({ label, selected, toggle, disabled = false, unknown = false }) => <div className='keyboardCheckbox'>
  <div className='keyboardCheckboxLabel'>{label}</div>
  <button type='button' role='switch' aria-label={label} aria-checked={!!selected}
    className={`keyboardCheckboxToggle ${selected ? 'keyboardCheckboxSelected' : 'keyboardCheckboxUnselected'}`}
    onClick={toggle} disabled={disabled} aria-busy={disabled}>
    {selected ? <>
      <span className='keyboardCheckboxLeft'/>
      <span className='keyboardCheckboxOn'>On</span>
    </> : <>
      <span className='keyboardCheckboxOff'>{unknown ? 'Retry' : 'Off'}</span>
      <span className='keyboardCheckboxOffButton'/>
    </>}
  </button>
  <div className='keyboardCheckboxRight'/>
</div>

export const KeyboardSettings = ({ getSetting, setSetting, toggleSetting, settingsError }) =>
  <div className='accountKeyboardSettings'>
    <div className='homeButtonLabel'>Keyboard settings</div>
    <div className='accountKeyboardSettingsCheckboxes'>
      <Checkbox label='Auto-Correction' selected={getSetting('autoCorrection')}
        toggle={() => toggleSetting('autoCorrection')}/>
      <AutocorrectionPreference value={getSetting('autoCorrectionLevel')}
        onChange={value => setSetting('autoCorrectionLevel', value)}/>
      <Checkbox label='Haptic Feedback' selected={getSetting('hapticFeedback')}
        toggle={() => toggleSetting('hapticFeedback')}/>
      <Checkbox label='Audio Feedback' selected={getSetting('audioFeedback')}
        toggle={() => toggleSetting('audioFeedback')}/>
      {settingsError && <div role='alert'>{settingsError}</div>}
    </div>
  </div>
